import React, { useState } from "react";
import type { Editor } from "codemirror";
import { Icon } from "../../../components";
import { pluralize } from "../../../utils";

type YaraEditorWarningControlsProps = {
  warnings: Array<{
    line: number;
    msg: string;
  }>;
  editor: Editor;
};

const WarningNavItem = ({
  onClick,
  text
}: {
  onClick: () => void;
  text: string;
}) => (
  <span onClick={onClick} className="yara-editor-warning-controls__nav_link">
    {text}
  </span>
);

const YaraEditorWarningControls = ({
  warnings,
  editor
}: YaraEditorWarningControlsProps) => {
  const [currentMarkerIndex, setCurrentMarkerIndex] = useState(-1);

  const navigateWarningMarkers = (direction: string) => {
    if (!editor) return;

    const markers = editor.getAllMarks();
    if (markers.length === 0) return;

    let newIndex;

    if (direction === "next") {
      newIndex = (currentMarkerIndex + 1) % markers.length;
    } else {
      newIndex = (currentMarkerIndex - 1 + markers.length) % markers.length;
    }
    setCurrentMarkerIndex(newIndex);
    const marker = markers[newIndex];
    const pos = marker.find();
    if (pos && "from" in pos) {
      editor.setCursor(pos.from);
      editor.focus();
    }
  };

  return (
    <div className="yara-editor-warning-controls">
      <Icon name="warning" className="yara-editor-warning-controls__icon" />{" "}
      Ruleset has{" "}
      {`${warnings.length} ${pluralize("warning", warnings.length)}`}
      <span className="ms-10">
        {warnings.length === 1 ? (
          <WarningNavItem
            onClick={() => navigateWarningMarkers("next")}
            text="Find"
          />
        ) : (
          <>
            <WarningNavItem
              onClick={() => navigateWarningMarkers("prev")}
              text="Prev"
            />
            {" / "}
            <WarningNavItem
              onClick={() => navigateWarningMarkers("next")}
              text="Next"
            />
          </>
        )}
      </span>
    </div>
  );
};

export default YaraEditorWarningControls;
